import { Avatar, Layout, Menu, ConfigProvider } from 'antd';
import { Outlet } from 'react-router-dom';
import { Menus, ExportRecordModal } from '@/components';
import zhCN from 'antd/es/locale/zh_CN';
import { HeaderDropdown } from '@/components';
// import headerSvg from '@/assets/header.svg';
import { useRecoilState } from 'recoil';
import { mainStore, exportModalVisibleStore } from './store';
import { goPlatformLogin, storageClear } from './utils/utils';
import type { MenuInfo } from 'rc-menu/lib/interface';
import * as api from '@/services/initial';
import { Down, AvatarFilledColor } from 'patternx-svg';
import { useMemo } from 'react';

const { Header, Content } = Layout;
const Main: React.FC = () => {
  const [currentUser] = useRecoilState(mainStore);
  const [exportModalVisible, setExportModalVisble] = useRecoilState(exportModalVisibleStore);

  const loginOut = async () => {
    await api.userOut();
    storageClear();
    goPlatformLogin({ noRedirect: true });
  };

  const showExportModal = () => {
    setExportModalVisble(true);
  };

  const onMenuClick = (event: MenuInfo) => {
    const { key } = event;
    if (key === 'logout') {
      loginOut();
      return;
    }
    if (key === 'export') {
      showExportModal();
      return;
    }
    return;
  };

  const menuHeaderDropdown = (
    <Menu
      selectedKeys={[]}
      onClick={onMenuClick}
      subMenuCloseDelay={0.2}
      className="user_info_menu"
    >
      <Menu.Item key="enterpriseInfo" className="enterprise_info">
        <Avatar
          size={64}
          className="avatar"
          src={currentUser.avatar || <AvatarFilledColor size={64} />}
          alt="avatar"
        />
        <p className="user_name" title={currentUser?.name}>
          {currentUser?.name && currentUser?.name?.length > 10
            ? `${currentUser?.name?.slice(0, 9)}...`
            : currentUser?.name}
        </p>
        <p className="enterprise_name">
          <span>{currentUser?.phone}</span>
        </p>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="export">我的导出任务</Menu.Item>
      <Menu.Divider />
      <Menu.Item key="logout" style={{ color: 'red' }}>
        {/* <LogoutOutlined /> */}
        退出登录
      </Menu.Item>
    </Menu>
  );

  const noMarginPathName = ['/source-material/list'];

  const contentStyle = useMemo(() => {
    if (noMarginPathName?.includes(window.location.pathname)) {
      return {
        minHeight: 'calc(100vh - 64px)',
      };
    } else {
      return {
        margin: 24,
        minHeight: 'calc(100vh - 112px)',
      };
    }
  }, [window.location.pathname]);

  return (
    <ConfigProvider locale={zhCN}>
      <Layout>
        <Header className="header" style={{ boxShadow: '0 1px 4px rgb(0 21 41 / 8%' }}>
          {/* <div className="logo" /> */}
          <div className="global_header_wrapper">
            <div className="logo" />
            <HeaderDropdown
              overlayClassName="headerDropdown"
              overlay={menuHeaderDropdown}
              trigger={['click']}
            >
              <span className={`global_header_action global_header_account`}>
                <Avatar
                  size={32}
                  className="avatar"
                  src={currentUser.avatar || <AvatarFilledColor size={32} />}
                  alt="avatar"
                />
                <Down size={16} color="#868b9c" />
                {/* <span className="anticon">{currentUser.name}</span> */}
              </span>
            </HeaderDropdown>
          </div>
        </Header>
        <Layout>
          <Menus />
          <Layout>
            <Content className="site-layout-background" style={contentStyle}>
              <Outlet />
            </Content>
          </Layout>
        </Layout>
      </Layout>
      <ExportRecordModal open={exportModalVisible} onCancel={() => setExportModalVisble(false)} />
    </ConfigProvider>
  );
};

export default Main;
